export default __webpack_public_path__ + "static/media/DAIF_Eco_Screen3_in-end.d1da8aaa.jpg";